import React, { useEffect, useState } from 'react';
import { AutoComplete } from 'antd';
import { MDBIcon } from 'mdbreact';
import { useTranslation } from 'react-i18next';
import { Modal, Button, Form } from 'react-bootstrap';
import AdminUserDetails from '../../api/AdminUserDetails';
import MasterPermissions from '../../api/MasterPermissions';
import CookiesService from '../../shared/CookiesService';
import './BreadcrumbModal.scss';

const BreadcrumbModal = (props) => {
  const {
    show,
    options,
    searchValue,
    optionsValue,
    allOptions,
    focused,
    selectedType,
  } = props;
  const { blobData, empData, locData } = props;
  const {
    onClose,
    onFocus,
    onSearch,
    onBlur,
    onSelect,
    onAllOptions,
    onApply,
  } = props;
  const { empBreadcrumb } = props;

  const [errorMsg, setErrorMsg] = useState('');
  const [disabled, setDisabled] = useState(false);
  const { t } = useTranslation();

  let modalTitle;
  let formLabel;
  let allText;
  const adminUserDetails = AdminUserDetails.getUserDetailResp();

  if (selectedType === 'blockOfBusiness') {
    modalTitle = 'Search "Block of Business"';
    formLabel = 'Block of Business';
    allText = 'All Block of Business';
  }
  if (selectedType === 'employer') {
    modalTitle = 'Search "Employers"';
    formLabel = 'Employers';
    allText = 'All Employers';
  }
  if (selectedType === 'location') {
    modalTitle = 'Search "Locations"';
    formLabel = 'Locations';
    allText = 'All Locations';
  }

  useEffect(() => {
    //Disabled based on page specific behavior
    if (
      window.location.href.includes('RegistrationSetUp') &&
      selectedType === 'location'
    ) {
      setErrorMsg('Location disabled on this page');
      setDisabled(true);
      return;
    }
    //Disabled if higher scope is not selected
    if (
      empBreadcrumb &&
      empBreadcrumb.key === 'all' &&
      selectedType === 'location'
    ) {
      setErrorMsg('Please select an Employer');
      setDisabled(true);
      return;
    }
    //Allow all permissions if Super User
    if (
      CookiesService.get('Superuser') === 'true' ||
      adminUserDetails?.Response?.User?.SuperUser
    ) {
      setErrorMsg('');
      setDisabled(false);
      return;
    }

    //Disabled based on permissions
    //if ( adminUserDetails?.Response?.User?.UserType === 'Insurer' ) {
    //if ( selectedType === 'employer' && !MasterPermissions.CheckPermission( 'View Allowed User settings for Clients' ) ) {
    //setErrorMsg( 'You do not have permission to view other employers' );
    //setDisabled( true );
    //return;
    //}
    //}

    setErrorMsg('');
    setDisabled(false);
  }, [empBreadcrumb, selectedType]);

  return (
    <Modal
      show={show}
      onHide={onClose}
      className="Right-Model breadcrumb-Modal"
    >
      <Modal.Header closeButton>
        <Modal.Title className="breadcrumb-title">{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="all-blockof-business-padding">
        <Form.Group controlId="formBasicEmail">
          <Form.Label>{formLabel}</Form.Label>
          <AutoComplete
            options={options}
            className="search-input"
            value={searchValue || optionsValue.value}
            onFocus={onFocus}
            onSearch={onSearch}
            onBlur={onBlur}
            onSelect={onSelect}
            placeholder="Search by Name or Unique ID"
            isValid
            disabled={disabled}
          ></AutoComplete>
          <MDBIcon className="text-white" icon="search" />
          <Form.Control className="d-none" isInvalid />
          <Form.Control.Feedback type="invalid">
            <span role="alert">{errorMsg}</span>
          </Form.Control.Feedback>
          {/*No Options Tooltip */}
          {focused &&
            options.length === 0 &&
            ((selectedType === 'blobOfBusiness' && blobData) ||
              (selectedType === 'employer' && empData) ||
              (selectedType === 'location' && locData)) && (
              <div className="no-options">No Options Available</div>
            )}
        </Form.Group>
        <Form.Check
          type="radio"
          aria-label="radio 1"
          id="selectedValue"
          for="selectedValue"
          label={allText}
          checked={allOptions}
          value={allOptions}
          onClick={onAllOptions}
          className="radio-input"
          disabled={disabled}
        />
        <div className="model-footer-btn">
          <Button variant="secondary" className="cancel-btn" onClick={onClose}>
            {t('label_cancel')}
          </Button>
          <Button
            onClick={onApply}
            className="apply-btn mr-0"
            disabled={disabled}
          >
            {t('label_apply')}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BreadcrumbModal;
